import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTouchId = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 16 16",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fill: "none",
		stroke: "currentColor",
		strokeWidth: .5,
		strokeLinecap: "round",
		strokeLinejoin: "round",
		d: "M12.2 9V8c0-2.6-1.9-4.5-4.2-4.5h0C5.7 3.5 3.8 5.4 3.8 8v4.2m8.4-.1v-1m-6.3 0v1"
	}), /* @__PURE__ */ _jsx("path", {
		fill: "none",
		stroke: "currentColor",
		strokeWidth: .5,
		strokeLinecap: "round",
		strokeLinejoin: "round",
		d: "M10.1 12.1V8.5c0-1.4-.9-2.4-2.1-2.4h0c-1.1 0-2.1 1-2.1 2.4V9M8 11.6v.5m0-3.9v1.6m7 2.4v1.9c0 .5-.4.9-.9.9h-1.9m0-14h1.9c.5 0 .9.4.9.9v1.9m-14 0V1.9c0-.5.4-.9.9-.9h1.9m0 14H1.9c-.5 0-.9-.4-.9-.9v-1.9"
	})]
});
export { SvgTouchId as ReactComponent };
